import React, { Component } from 'react';
import { Button, Card, CardBody, CardFooter, CardHeader, Col, FormGroup, Label, Row } from 'reactstrap';
import AxiosInstance from '../../../components/AxiosInstance/AxiosInstance';
import toast from "../../../components/ErrorHandler/toast.js"
import Language from '../../../components/Language/Language.js';
import '../../../css/views/BCMUser/ScorecardMasterSelection/ScorecardMasterSelection.css';
import "../../../css/react-checkbox-tree/react-checkbox-tree.css";
import
DetailLevel from '../../../components/ScorecardDetailLevel/ScorecardDetailLevel';
import ScorecardSelection from '../../../components/ScorecardMasterSelection/ScorecardMasterSelection';
import ScorecardDetailLevelWithoutModal from '../../../components/ScorecardDetailLevel/ScorecardDetailLevelWithoutModal'
import BCMProfile from '../../../views/BCMDashboard/BCMProfile/BCMProfile';

class ScorecardMasterSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      dcKey: 0,
      list: 1,
      grid: 0
    };

    this.ref = React.createRef();
    this.toggleModal = this.toggleModal.bind(this);
    this.levelHandler = this.levelHandler.bind(this);
    this.SearchLevel = this.SearchLevel.bind(this);
    this.listView = this.listView.bind(this);
    this.gridView = this.gridView.bind(this);
  }

  componentDidUpdate() {
    Language.BindLanguageControl();
  }


  toggleModal() {
    this.setState({
      modal: !this.state.modal,
    });
  }

  levelHandler(checked) {
    var self = this;
    if (checked !== null) {
      self.setState({
        Level: checked
      })

      var siLevelGroupID;
      var dcLevelID;
      var dcKey;
      if (checked.length > 0) {
        var data = checked[0].split("&");
        siLevelGroupID = data[0];
        dcLevelID = data[1];
        dcKey = siLevelGroupID + dcLevelID;
      }

      self.setState({
        dcKey: dcKey
      })
    }
  }

  SearchLevel() {
    this.ref.current.SearchLevel();
  }

  listView() {
    this.setState({
      list: 0,
      grid: 1
    })
  }

  gridView() {
    this.setState({
      grid: 0,
      list: 1
    })
  }

  render() {
    return (
      <div className="scoreCard-contentframe">

        <div>
          <Button className="primary" className="pull-right mx-1" onClick={this.listView} data-langid="9396.01">List View</Button>
          <Button className="primary" className="pull-right mx-1" onClick={this.gridView} data-langid="9397.01">Grid View</Button>
        </div>

        <br /><br />

        <div hidden={this.state.list} >
          <ScorecardSelection ref={this.ref} dcKey={this.state.dcKey} />
        </div>

        <div hidden={this.state.grid}>
          <BCMProfile />
        </div>

      </div>
    )
  }
}

export default ScorecardMasterSelection;
